export default __webpack_public_path__ + "static/media/Walk (6).8fdf5f6f.png";